<div class="custom-ng-select-container">
    <ng-select [isOpen]="isOpen" [items]="items" [multiple]="multiselect" [loading]="loading" [bindLabel]="bindLabel"
        [(ngModel)]="selectedItems" [searchable]="true" [clearSearchOnAdd]="true" [ngModelOptions]="{standalone: true}"
        (close)="rearrangeItems()" (ngModelChange)="emitSelection()" notFoundText="Nothing here"

         (clear)="clearSelection()"
        [placeholder]="placeholder" [closeOnSelect]="closeOnSelect" [disabled]="isdisabled">

        <!--dropdownPosition="bottom"-->
        <!-- Label template -->
        <ng-template ng-label-tmp let-item="item" *ngIf="!multiselect">
            <span *ngIf="item?.fullName; else elseBLock" class="d-flex align-items-center">
                <img height="17" width="17" class="mr-1 border border-light rounded p-1"
                    [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'"
                    onError="this.onerror=null; this.src='assets/common/images/default-profile-picture1.svg'" />
                <!-- {{item.fullName}} -->
                <span pTooltip="{{item.fullName}}" [tooltipDisabled]="false" tooltipPosition="bottom">
                    {{
                    item.fullName |
                    slice:0:20
                    }}{{item.fullName?.length > 20 ? '...' : '' }}
                </span>
            </span>
            <ng-template #elseBLock>
                <img height="17" width="17" class="mr-1 border border-light rounded p-1"
                    [src]="item[0]?.profileImage ? item[0]?.profileImage : 'assets/common/images/default-profile-picture1.svg'"
                    onError="this.onerror=null; this.src='assets/common/images/default-profile-picture1.svg'"/>
                <!-- {{item.fullName}} -->
                <span pTooltip="{{item[0]?.fullName}}" [tooltipDisabled]="false" tooltipPosition="bottom">
                    {{
                        item[0]?.fullName |
                    slice:0:20
                    }}{{item[0]?.fullName?.length > 20 ? '...' : '' }}
                </span>
            </ng-template>
        </ng-template>

        <!-- Multi label -->
        <ng-template ng-multi-label-tmp let-items="items" *ngIf="multiselect" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:2">
                <span class="ng-value-label d-flex align-items-center">
                    <img height="17" width="17" class="mr-1 border border-light rounded p-1"
                        [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'"
                        onError="this.onerror=null; this.src='assets/common/images/default-profile-picture1.svg'"/>
                    <!-- {{item.fullName}} -->
                    <span pTooltip="{{item.fullName}}" [tooltipDisabled]="false" tooltipPosition="bottom">
                        {{
                        item.fullName | slice:0:7
                        }}{{item.fullName?.length > 7 ? '...' : '' }}
                    </span>
                    <span class="ng-value-icon right ml-3" (click)="clear(item)" aria-hidden="true">×</span>
                </span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
                <span class="ng-value-label">{{items.length - 2}} {{'More'|localize}}</span>
            </div>
        </ng-template>


        <!-- Multiselet Option template -->
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div class="d-flex" >
                <div class="checkbox mr-0">
                    <input id="item-{{index}}" type="checkbox"
                    [ngModel]="item$.selected"
                    [ngModelOptions]="{standalone: true}" />
                <span (click)="checkUncheck(item$.selected)"></span>
             </div>
                    <!-- <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{standalone: true}" (click)="checkUncheck(item$)" /> {{setNoDataFound(false)}}
                    <span ></span> -->

                <div class="d-flex justify-content-center align-items-center rounded mx-1"
                    style="width: 40px; height: 40px;">
                    <img style="width: 40px; height: 40px;" onError="this.onerror=null; this.src='assets/common/images/default-profile-picture1.svg'"
                        src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                        class="border border-light rounded p-1" id="profimgsize">
                </div>
                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75"
                    *ngIf="shortName !== true">
                    <div class="font-weight-bold">
                        <!-- {{ item.fullName | titlecase }} -->
                        <!-- {{item.fullName | slice:0:27 }}{{item.fullName ?.length>27? '..': ''}} -->
                        <span pTooltip="{{item.fullName}}" [tooltipDisabled]="item.fullName?.length < 15"
                            tooltipPosition="bottom">
                            {{
                            item.fullName|titlecase|slice:0:15
                            }}{{item.fullName?.length > 15 ? '...' : '' }}
                        </span>
                    </div>
                    <div style="font-size: 0.8rem;">
                        <!-- {{ item.emailAddress }}  -->
                        <!-- {{item.emailAddress | slice:0:27 }}{{item.emailAddress ?.length>27? '..': ''}} -->
                        <span pTooltip="{{item.roleNames?.toString().replace(',' , ', ')}}" [tooltipDisabled]="item.roleNames?.toString().replace(',' , ', ').length<20"
                            tooltipPosition="bottom">
                            {{item.roleNames?.toString().replace(',' , ', ') | slice:0:20 }}{{item.roleNames?.length > 20 ? '...' : ''}}
                        </span>
                    </div>
                    <div style="font-size: 0.8rem;">
                        <!-- {{ item.emailAddress }}  -->
                        <span pTooltip="{{item.emailAddress}}" [tooltipDisabled]="item.emailAddress?.length<20"
                            tooltipPosition="bottom">
                            {{item.emailAddress | slice:0:20 }}{{item.emailAddress ?.length>20? '...': ''}}
                        </span>

                    </div>
                </div>
                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75"
                    *ngIf="shortName === true">
                    <div class="font-weight-bold" pTooltip="{{ item.fullName | titlecase }}"
                        tooltipStyleClass="member-filter-ttoltip" tooltipPosition="bottom">
                        {{ item.name | titlecase }} {{
                        item.surname | titlecase | slice:0:1
                        }}
                    </div>
                    <div *ngIf="item.roles && roleName" style="font-size: 0.8rem;">{{item.roles[0]?.roleName |
                        localize}}</div>
                </div>
            </div>
        </ng-template>


        <!-- Option template -->
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="!multiselect">
            <div class="d-flex">
                <div class="d-flex justify-content-center align-items-center rounded mx-1"
                    style="width: 44px; height: 44px;">
                    <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                        onError="this.onerror=null; this.src='assets/common/images/default-profile-picture1.svg'"
                        class="img-fluid border border-light rounded p-1" id="profimgsize">
                </div>
                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                    <div class="font-weight-bold ">
                        <!-- {{ item.fullName | titlecase }} -->
                        <span pTooltip="{{item.fullName}}" [tooltipDisabled]="false" tooltipPosition="bottom">
                            {{
                            item.fullName | slice:0:15
                            }}{{item.fullName?.length > 15 ? '...' : '' }}
                        </span>
                    </div>
                    <div class="dropdown-rolename ">{{ item.emailAddress }}</div>
                </div>
            </div>
        </ng-template>


        <!-- Header template -->
        <ng-template ng-header-tmp *ngIf="multiselect && items && items.length">
            <div *ngIf="!noDataFound" class="d-flex cursor-pointer" (click)="showselectall ? selectAll() : unselectAll()">
                <label *ngIf="showselectall" class="checkbox ml-1 mr-2">
                    <input id="item" name="item"  type="checkbox" [(ngModel)]="!showselectall"
                        />
                    <span></span>
                </label>
                <label *ngIf="showdeselectall" class="checkbox ml-1 mr-2">
                    <input id="item" name="item"  type="checkbox" [(ngModel)]="!showselectall"
                        />
                    <span></span>
                </label>
                <span *ngIf="showselectall" class="pointer my-2">{{'Selectall' | localize}}</span>
                <span *ngIf="showdeselectall" class="pointer my-2">{{'Selectall' | localize}}</span>
            </div>
        </ng-template>

        <!-- Footer template -->
        <ng-template *ngIf="multiselect && items && items.length" ng-footer-tmp>
            <div class="text-muted" style="font-size: 0.8rem;">
                {{ selectedItems ? selectedItems.length : '0' }} {{
                selectedItems && (selectedItems.length === 0 || selectedItems.length > 1) ? ('items' | localize) :
                'Item' | localize
                }} {{'selected' | localize}}
            </div>
        </ng-template>

        <!-- Loader template -->
        <ng-template ng-loadingspinner-tmp>
            <div class="spinner spinner-primary mr-7"></div>
        </ng-template>

        <!-- Type to search -->
        <ng-template ng-typetosearch-tmp>
            <div class="ng-option disabled">
                {{'Starttyping' | localize}}
            </div>
        </ng-template>

        <!-- Not found -->
        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
                {{'Nodatafoundfor' | localize}}{{setNoDataFound(true)}}
            </div>
        </ng-template>

        <!-- Loading template -->
        <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled d-flex justify-content-center align-items-center">
                <div class="spinner spinner-primary my-4"></div>
            </div>
        </ng-template>
    </ng-select>
</div>
